exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sp_label[data-v-52f37e5c] {\n    min-width: 4rem;\n}\n", ""]);

// exports
